import React from 'react';
import { FilterTypes } from '@digitalexperience/dealer-website-core';
import GenericColorList from '../../../../../components/common/GenericColorList';
import { find } from 'lodash';

const InteriorColorFilter = ({ filterData, filterValues, filterAdd, filterDelete }) => {
  const handleChange = (data) => {
    const hasFilterForColor = find(filterValues, (i) => i === data.value);
    if (hasFilterForColor) {
      filterDelete(FilterTypes.interiorColor, data.value);
    } else {
      filterAdd(FilterTypes.interiorColor, data.value);
    }
  };

  return (
    <React.Fragment>
      <div className='builder-font-semibold builder-mb-2 builder-mt-5'>Interior color</div>
      <GenericColorList placeHolder='All' items={filterData} values={filterValues} handleFilterChanged={handleChange} />
    </React.Fragment>
  );
};

export default InteriorColorFilter;
